import RoutesApp from './routes';
import './App.css';

function App() {
  return (
   <div>
      <RoutesApp/>
   </div>
  );
}
export default App;
